import { render, staticRenderFns } from "./AncestralTabletsEngraving.vue?vue&type=template&id=51f0e5f0&"
import script from "./AncestralTabletsEngraving.vue?vue&type=script&lang=js&"
export * from "./AncestralTabletsEngraving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports